// extracted by mini-css-extract-plugin
export default {"container":"style_container__QSi3a","chatPlaceholder":"style_chatPlaceholder__Tf9kS"};